var awayLogSummaryTable;

function InitAwayLogSummaryDataTable(dateFormat) {

    /*  $(document).ready(function () {*/
    console.log("creating new table1");

    if (awayLogSummaryTable != null) {
        try {
            awayLogSummaryTable.destroy();
            awayLogSummaryTable = null;
        } catch (e) {

        }
    }

    awayLogSummaryTable = $('#awayLogSummaryViewList').DataTable({
        "order": [[3, "desc"]],
        pageLength: 25,
        autoWidth: false,
        "columnDefs": [
            { "width": "48px", "targets": 0 }, //Unit
            { "width": "64px", "targets": 1 }, //Name
            { "width": "64px", "targets": 2 }, //Description
            { "width": "96px", "targets": 3 }, //Departed
            { "width": "96px", "targets": 4 }, //Returning
            { "width": "56px", "targets": 5 }, //Duration
            { "width": "56px", "targets": 6 }, //Title
            { "width": "56px", "targets": 7 } //Assigned to
        ],
        "language": {
            "emptyTable": "There are currently no away log entries.",
            "info": "Showing _START_ to _END_ of _TOTAL_ away log entries",
            "infoEmpty": "Showing 0 to 0 of 0 away log entries",
            "infoFiltered": "(filtered from _MAX_ total away log entries)",
            "lengthMenu": "Show _MENU_ away log entries"
        },
        columns: [
            {
                data: 'unit',
            },
            {
                data: "name"
            },
            {
                data: "description"
            },
            {
                data: 'departed',
                render: function (data, type) {
                    if (type === 'display') {
                        return awayLogSummaryToDate(data, dateFormat);
                    }

                    return data;
                }
            },
            {
                data: 'returning',
                render: function (data, type) {
                    if (type === 'display') {
                        return awayLogSummaryToDate(data, dateFormat);
                       
                    }

                    return data;
                }
            },
            {
                data: "duration"
            },
            {
                data: "returnsin"
            },
            {
                data: "text"
            },
           

        ]
    });

    $('#awayLogSummaryViewList tbody').on('click', 'tr', function () {
        var data = awayLogSummaryTable.row(this).data();
        console.log(data);

        var taskNumberParsed = -1;

        try {
            taskNumberParsed = parseInt(data.taskNumber);
        } catch (e) {

        }

        if (taskNumberParsed > 0) {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnTaskClickedFromGrid', taskNumberParsed);
        }



    });

    $("#awayLogSummaryViewList tr").css('cursor', 'pointer');

    //});

    return 1;
}

function awayLogSummaryToDate(data, dateFormat) {

    var resultDate = '';

    try {
      
        var dd = data.getDate();
        var yy = data.getFullYear();
        var parsedDate = moment(data);
        if (data != null) {
            if (dateFormat == 0) {

                resultDate = dd + " " + parsedDate.format('MMMM') + ", " + yy
            } else {
                resultDate = parsedDate.format('MMMM') + " " + dd + ", " + yy;
            }

        
        }
    } catch (e) {
        resultDate = '';
    }

    return resultDate;
}

function FilterTaskDataTableOnAssignedTo(assignedToName) {
    if (awayLogSummaryTable != null) {
        awayLogSummaryTable.columns(6).search(assignedToName).draw();
    }

}

function RemoveAssignedToFilterAwayLogSummaryDataTable(arg) {
    if (awayLogSummaryTable != null) {
        awayLogSummaryTable.columns(6).search('').draw();
    }

}

function PopulateToAwayLogSummaryDataTable(rows) {

    console.log("PopulateToAwayLogSummaryDataTable");
    console.log(rows);

    var summary = [];

    rows.forEach(row => summary.push({
        unit: row.awayLogSummaryEntryUnit,
        name: row.awayLogSummaryEntryName,
        description: row.awayLogSummaryEntryDescription,
        departed: row.awayLogSummaryEntryDeparted == null ? null : new Date(row.awayLogSummaryEntryDeparted),
        returning: row.awayLogSummaryEntryReturning == null ? null : new Date(row.awayLogSummaryEntryReturning),
        duration: row.awayLogSummaryEntryDurationFormatted,
        returnsin: row.awayLogSummaryEntryReturnsInFormatted,
        text: row.awayLogSummaryEntryExtra
    }));

    //  tasks = tasks.reverse();

  

    try {
        awayLogSummaryTable.rows().remove()
    } catch (e) {
        console.log(e);
    }


    try {
        awayLogSummaryTable.rows.add(summary);
        awayLogSummaryTable.draw();

    } catch (e) {
        console.log(e);
    }



    console.log("updated");
}